import ArticleLayout from '@/components/feature/ArticleLayout';

export default function BeginnerGuide() {
  return (
    <ArticleLayout
      pageTitle="Kakobuy Spreadsheet dla początkujących – poradnik krok po kroku 2026 | KakobuyFinds"
      title="Kakobuy Spreadsheet dla początkujących – kompletny poradnik krok po kroku"
      description="Nigdy nie korzystałeś z Kakobuy? Ten poradnik przeprowadzi Cię przez cały proces – od pierwszej wizyty w arkuszu po pierwsze udane zakupy."
      category="Poradniki"
      readTime="8 minut czytania"
      breadcrumbs={[{ label: 'Strona główna', href: '/' }, { label: 'Poradnik dla początkujących' }]}
      faqData={[
        { question: 'Od czego zacząć z Kakobuy Spreadsheet?', answer: 'Zacznij od otwarcia arkusza i wybrania interesującej Cię kategorii. Przeglądaj produkty, porównuj oferty i klikaj w linki, aby przejść do strony produktu na platformie Kakobuy.' },
        { question: 'Czy potrzebuję specjalnego konta?', answer: 'Do przeglądania Kakobuy Spreadsheet nie potrzebujesz konta. Konto jest wymagane tylko na platformie Kakobuy do składania zamówień.' },
      ]}
      articleSchema={{ '@context': 'https://schema.org', '@type': 'Article', headline: 'Kakobuy Spreadsheet dla początkujących', description: 'Kompletny poradnik krok po kroku.', author: { '@type': 'Organization', name: 'KakobuyFinds' }, datePublished: '2026-07-16', dateModified: '2026-07-16', inLanguage: 'pl', publisher: { '@type': 'Organization', name: 'KakobuyFinds' } }}
    >
      <section>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">1. Czym właściwie jest Kakobuy Spreadsheet?</h2>
        <p className="text-sm md:text-base mb-4">
          <strong>Kakobuy Spreadsheet</strong> to po prostu arkusz kalkulacyjny wypełniony linkami do najlepszych produktów na platformie Kakobuy. Zamiast godzinami szukać produktów ręcznie, otwierasz arkusz i masz wszystko gotowe. Proste!
        </p>
      </section>
      <section>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">2. Jak zacząć – 4 proste kroki</h2>
        <ol className="space-y-4 my-6">
          {[
            { step: 'Otwórz arkusz', desc: 'Kliknij przycisk "Kakobuy Spreadsheet" na naszej stronie. Arkusz otworzy się w nowej karcie.' },
            { step: 'Wybierz kategorię', desc: 'Arkusz ma 14 kategorii – od butów po perfumy. Wybierz to, co Cię interesuje.' },
            { step: 'Przeglądaj produkty', desc: 'Każdy wpis to link do konkretnego produktu na platformie Kakobuy. Kliknij i sprawdź szczegóły.' },
            { step: 'Kupuj mądrze', desc: 'Przed zakupem sprawdź ocenę sprzedawcy i opinie innych kupujących.' },
          ].map((item, idx) => (
            <li key={idx} className="flex items-start gap-3 text-sm md:text-base">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-semibold text-sm shrink-0">{idx + 1}</span>
              <div>
                <p className="font-semibold text-foreground-800">{item.step}</p>
                <p className="text-foreground-600 mt-0.5">{item.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>
      <section>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">3. Najczęstsze błędy początkujących</h2>
        <p className="text-sm md:text-base mb-4">Unikaj tych pułapek, które czyhają na nowych użytkowników <strong>Kakobuy Spreadsheet</strong>:</p>
        <ul className="space-y-2 my-4 text-sm">
          <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5"></i>Nie sprawdzanie rozmiarów – azjatyckie rozmiary różnią się od europejskich</li>
          <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5"></i>Pomijanie opinii innych kupujących</li>
          <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5"></i>Zamawianie bez sprawdzenia kosztów wysyłki do Polski</li>
          <li className="flex items-start gap-2"><i className="ri-close-line text-primary-500 mt-0.5"></i>Kupowanie od niezweryfikowanych sprzedawców</li>
        </ul>
      </section>
    </ArticleLayout>
  );
}